import React, { useState, useEffect, useRef } from "react";
import { Shield, BarChart3, Users, Scale } from "lucide-react";

import Banner from "../components/Banner";
import bannerimg from "../assets/img/cookiesbg.jpg";
import CTA from "../components/CTA";
import { Link } from "react-router-dom";

function CookiePolicy() {
 
  return (
    <>
      <div className="position-relative">

        <Banner
          containerWidth="w-50"
          title="Our Cookie Policy: Industry & People"
          subtitle="We use cookies to enhance your browsing experience, keep your account secure, and improve our platform. Learn how cookies help us deliver a seamless and personalized experience while protecting your privacy."
          bgImage={bannerimg}
          headingcenter="text-center"
        />

        <section className="bg-white px-3 ptb60px pb100px prtext">
          <div className="container">
            <div className="row g-5">
                
                {/* RIGHT CONTENT */}
                <div className="col-lg-12 rightpart">

                    {/* SECTION 1 */}
                    <section className="mb50px" data-aos="fade-up">
                        <h2>
                        <span className="">1.</span> Introduction
                        </h2>
                        <p className="mb-2 fw-bold">Welcome to Industry & People (I&P), operated by Internet Research Bureau (IRB).</p>

                        <p className="">This Cookie Policy explains how we use cookies and similar technologies when you visit or use our website, including during registration, login, survey participation, and while browsing our platform.</p>

                        <p>By continuing to use our website, you consent to the use of cookies as described in this policy. Where required by applicable law, we will request your consent before placing non-essential cookies on your device.</p>
                        
                    </section>

                    {/* SECTION 2 */}
                    <section className="mb50px" data-aos="fade-up">
                        <h2>
                        <span className="">2.</span> What Are Cookies?
                        </h2>

                        <p className="">Cookies are small text files that are stored on your computer, tablet, or mobile device when you visit a website. They help websites remember your preferences, improve functionality, enhance security, and provide a better browsing experience.</p>
                        <p className="">Cookies do not typically contain information that directly identifies you, but they may be linked to information you voluntarily provide to us.</p>
                        
                    </section>
                    
                    <section className="mb50px" data-aos="fade-up">
                        <h2>
                            <span className="">3.</span> Why We Use Cookies
                        </h2>

                        <p className="mb-2 fw-bold">We use cookies to:</p>                            

                        <ul className="fullrow">
                            <li>Keep you securely logged into your account</li>
                            <li>Remember your preferences and settings</li>
                            <li>Improve website performance and usability</li>
                            <li>Analyze website traffic and visitor behavior</li>
                            <li>Prevent fraud and unauthorized access</li>
                            <li>Enhance security during registration and login</li>
                            <li>Understand how users interact with our surveys and platform</li>
                            <li>Improve user experience and platform performance</li>
                        </ul>
                    </section>                

                    <section className="mb50px" data-aos="fade-up">
                        <h2>
                            <span className="">4.</span> Types of Cookies We Use 
                        </h2>

                        <p className="fw-bold">1. Strictly Necessary Cookies</p>
                        <p className="fw-bold">These cookies are essential for the website to function properly.</p>
                        <p className="fw-bold">They help us:</p>
                        <ul className="fullrow">
                            <li>Authenticate users</li>
                            <li>Maintain secure login sessions</li>
                            <li>Protect against fraudulent activity</li>
                            <li>Process membership applications</li>
                            <li>Enable core website functionality</li>
                        </ul>
                        <p className="">Without these cookies, certain parts of our website may not function correctly.</p>


                        <p className="fw-bold mt-5">2. Functional Cookies</p>
                        <p className="fw-bold">These cookies remember choices you make, such as:</p>
                        <ul className="fullrow">
                            <li>Language preferences</li>
                            <li>Region or country</li>
                            <li>User settings</li>
                            <li>Form preferences</li>
                        </ul>

                        <p className="">They help provide a more personalized experience.</p>


                        <p className="fw-bold mt-5">3. Analytics Cookies</p>
                        <p className="fw-bold">Analytics cookies help us understand how visitors use our website.</p>
                         <p className="fw-bold">We may collect information such as:</p>
                        <ul className="mb-4 fullrow">
                            <li>Pages visited</li>
                            <li>Time spent on pages</li>
                            <li>Device type</li>
                            <li>Browser type</li>
                            <li>Operating system</li>
                            <li>Referral source</li>
                            <li>Anonymous traffic statistics</li>
                        </ul>

                        <p className="">This information helps us improve our website and services.</p>


                        <p className="fw-bold mt-5">4. Performance Cookies</p>
                        <p className="">Performance cookies allow us to monitor website speed, loading times, and technical issues so we can improve the overall user experience.</p>


                        <p className="fw-bold mt-5">5. Security Cookies</p>
                        <p className="">Security cookies help us:</p>
                        <ul className="fullrow">
                            <li>Detect suspicious activity</li>
                            <li>Prevent unauthorized access</li>
                            <li>Protect user accounts</li>
                            <li>Secure our platform against misuse</li>
                        </ul>                        
                    </section>


                    <section className="mb50px" data-aos="fade-up">
                        <h2>
                            <span className="">5.</span> Third-Party Cookies
                        </h2>

                        <p className="fw-bold">Some cookies may be placed by trusted third-party service providers that help us operate and improve our website.</p>

                        <p>These may include services for:</p>
                        
                        <ul className="fullrow">
                            <li>Website analytics</li>
                            <li>Performance monitoring</li>
                            <li>Security</li>
                            <li>CAPTCHA verification</li>
                            <li>Website optimization</li>
                        </ul> 
                        
                    </section>

                    <section className="mb50px" data-aos="fade-up">
                        <h2>
                            <span className="">6.</span> Managing Cookies
                        </h2>

                        <p className="fw-bold">Most web browsers allow you to:</p>
                        
                        <ul className="fullrow">
                             <li>View stored cookies</li>
                            <li>Delete cookies</li>
                            <li>Block cookies</li>
                            <li>Control cookie preferences</li>
                        </ul>

                        <p>Please note that disabling essential cookies may affect certain website features, including account login and survey participation.
                        </p>

                        <p>For browser-specific instructions, please refer to your browser's Help section.
                        </p>


                    </section>

                    <section className="mb50px" data-aos="fade-up">
                        <h2>
                            <span className="">7.</span> Cookie Retention
                        </h2>

                        <p className="">Different cookies remain on your device for different periods.</p>
                        
                        <ul className="fullrow">
                            <li>
                                <strong>Session Cookies:</strong> These are deleted automatically when you
                                close your browser.
                            </li>
                            <li>
                                <strong>Persistent Cookies:</strong> These remain on your device until they
                                expire or are manually deleted.
                            </li>
                        </ul>
                    </section>

                    <section className="mb50px" id="suspension" data-aos="fade-up">
                        <h2>
                            <span className="">8.</span> Updates to This Cookie Policy
                        </h2>

                        <p className="">We may update this Cookie Policy from time to time to reflect changes in technology, legal requirements, or our services.</p>                       

                        <p className="">Any updates will be posted on this page along with the revised "Last Updated" date.</p>
                    </section>
                    

                    <section className="mb50px" data-aos="fade-up">
                        <h2>
                            <span className="">9.</span> Contact Us
                        </h2>

                        <p>If you have any questions regarding this Cookie Policy or our use of cookies,
                        please contact us:</p>

                        <ul className="fullrow">
                        <li><strong>Industry &amp; People (I&amp;P)</strong></li>
                        <li><strong>Internet Research Bureau (IRB)</strong></li>
                        <li><strong>Email:</strong> <a href="mailto:support@iptest.irbureau.com" className="textbluecolor">support@iptest.irbureau.com</a> (replace with your official support email if different)</li>

                        <li><strong>Website:</strong> <Link to="/" className="textbluecolor text-decoration-none">Industry &amp; People</Link></li>
                        </ul>
                    </section>

                </div>
            </div>
          </div>
        </section>

        <CTA />
      </div>
    </>
  );
}

export default CookiePolicy;